import Vue from "vue";
import { STATUS_DRAFT, STATUS_PUBLISH, STATUS_PENDING } from "./const";
const plugin = {
  install(Vue) {
    // 4. add an instance method
    Vue.prototype.$kelas = {
      statusColor: status => {
        switch (+status) {
          case STATUS_PUBLISH:
            return "success";
          case STATUS_PENDING:
            return "pending";
          case STATUS_DRAFT:
            return "grey";
          default:
            return "default";
        }
      },
      STATUS_DRAFT,
      STATUS_PUBLISH,
      STATUS_PENDING
    };
    Vue.prototype.$statuskelas = {
      statusColor: status => {
        switch (+status) {
          case 1:
            return "success";
          case 0:
            return "orange";
          default:
            return "default";
        }
      }
    };
    Vue.prototype.$labelstatus = {
      statusColor: status => {
        switch (+status) {
          case 0:
            return "Luring";
          default:
            return "Daring";
        }
      },
      STATUS_DRAFT,
      STATUS_PUBLISH,
      STATUS_PENDING
    };
  }
};

Vue.use(plugin);
